import h from '../../helpers/common';
import { setLockedFlag } from './common';
import { __ } from '../../translations';
import channelsUtil from '../../helpers/channelsUtil';
import _ from 'lodash';

export const transformPerson = (item) => {
    return {
        id: item.id.search('/') === -1 ? item.id : item.id.split('/').pop(),
        guid: item.guid,
        updated: item.updated,
        image:
            typeof item.thumbnails.smallThumb !== 'undefined'
                ? item.thumbnails.smallThumb.url
                    ? item.thumbnails.smallThumb.url
                    : ''
                : '',
        title: h.getLang() === 'en' ? item.title : item.titleLocalized.ar,
        titleAr: item.titleLocalized.ar,
        position:
            item.credits && item.credits.length
                ? _.uniqBy(item.credits as any[], 'creditType')
                      .map((credit: any) => credit.creditType)
                      .filter(Boolean)
                : '',
        subscriptionGuids: item.pl1$subscriptionGuids,
    };
};

export const transformResponseDetailsCastCrew = (data) => {
    if (typeof data.entries !== 'object') {
        return [];
    }
    return data.entries.map((item) => transformPerson(item));
};

export const transformResponseGetProductsByMediaId = (response) => {
    if (response && response.entries) {
        const products = response.entries.map(({ pricingTemplateId, scopes, id }) => {
            const mediaId = scopes[0]?.id;
            return {
                id,
                mediaId,
                pricingTemplateId,
            };
        });
        return products;
    } else {
        return [];
    }
};

export const transformVOD = (vod) => {
    const providers = h.getProviders();
    let contentObject = vod.media;
    let trailer = null;
    let streamingUrl = null;
    let trailerMediaUrl = null;
    if (
        vod.media &&
        vod.media.length > 0 &&
        !!vod.media[0] &&
        typeof vod.media[0].content !== 'undefined' &&
        vod.media[0].content !== null
    ) {
        contentObject = vod.media[0].content;
        let trailerM3U8 = [];
        let vodStreamingUrl = [];
        let trailerMedia = [];

        trailerM3U8 = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer-MP4';
        });

        trailerMedia = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer';
        });

        vodStreamingUrl = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Video' && cnt.format === 'M3U';
        });

        if (trailerM3U8.length > 0) {
            trailer = trailerM3U8[0].streamingUrl;
        }

        if (trailerMedia?.length > 0) {
            trailerMediaUrl = trailerMedia[0].releases[0]?.url;
        }

        if (vodStreamingUrl.length > 0) {
            streamingUrl = vodStreamingUrl[0].releases[0] ? vodStreamingUrl[0].releases[0].url : '';
            //streamingUrl = vodStreamingUrl[0].streamingUrl;
        }
    }

    let result = {
        assetId: vod?.assetId || null,
        Id: vod.id,
        guid: vod.guid ? vod.guid : '',
        text: h.getLang() === 'ar' ? vod.titleLocalized?.ar : vod.title,
        textEn: vod.title,
        name: vod.title,
        description: h.getLang() === 'en' ? vod.description : vod.descriptionLocalized.ar,
        descriptionEn: vod.description,
        image: vod.thumbnails['portrait-highestResolution'] ? vod.thumbnails['portrait-highestResolution'].url : '',
        image_landscape: vod.thumbnails['landscape-highestResolution']
            ? vod.thumbnails['landscape-highestResolution'].url
            : '',
        year: vod.year,
        tags: vod.tags,
        genre: vod?.tags?.filter((i) => i.scheme === 'Genre' && i.title).map((el) => el.title) ?? [],
        provider: vod?.tags?.filter((i) => i.scheme === 'Categories' && i.title in providers).map((i) => i.title) ?? [],
        categories:
            (!!vod.tags &&
                _.filter(vod.tags, (i) => i.scheme === 'Categories' && !(i.title in providers)).map((i) => i.title)) ||
            [],
        ratings: h.getGenreRating(vod.ratings),
        duration: vod.runtime,
        language: vod.languages ? vod.languages : '',
        programType: vod.programType,
        tvSeasonEpisodeNumber: vod.tvSeasonEpisodeNumber,
        streamingUrl: streamingUrl,
        trailer: trailer,
        trailerMediaUrl: trailerMediaUrl,
        seriesId: vod.seriesId,
        tvSeasonNumber: vod.tvSeasonNumber,
        tvSeasonId: vod.tvSeasonId,
        subscriptionGuids: vod?.pl1$subscriptionGuids ?? vod?.subGuids ?? null,
        category: 'VOD',
        mediaId: vod.media && vod.media.length > 0 ? vod.media[0].id : null,
        promoType: false,
        introEt: vod.pl1$introEt,
        introSt: vod.pl1$introSt,
        outroEt: vod.pl1$outroEt,
        outroSt: vod.pl1$outroSt,
        paId: vod.id,
        listingId: vod?.listingId ?? null,
        categoryType: vod?.pl1$categoryType ?? null,
        adEnabled: vod?.pl1$adEnabled ?? null,
        pl1$seasonOrderDescending: vod?.pl1$seasonOrderDescending ?? null,
    };

    result = setLockedFlag(result);

    return result;
};

export const transformResponseList = (responseData) => {
    return (responseData.entries || []).map((vod) => transformVOD(vod));
};

export const transformFilmography = (data) => {
    const language = h.getLang();
    const providers = h.getProviders();

    return data.map((credit) => {
        let result = {
            Id: credit.id.search('/') === -1 ? credit.id : credit.id.split('/').pop(),
            id: credit.id,
            guid: credit.guid,
            title: language === 'en' ? credit.title : credit.titleLocalized.ar,
            image:
                credit?.images
                    ?.find((creditImage: any) => creditImage.type === 'poster')
                    ?.url?.replace(/^http:/, 'https:') || '',
            cover:
                credit?.images
                    ?.find((creditImage: any) => creditImage.type === 'cover')
                    ?.url?.replace(/^http:/, 'https:') || '',
            programType: credit.programType,
            seriesId: credit.seriesId,
            seriesGuid: credit.seriesGuid || '',
            subscriptionGuids: credit.subscriptionGuids,
            tags: credit?.tags,
            ratings: h.getGenreRating(credit?.parentalRatings),
            mediaId: credit?.contents && credit?.contents.length > 0 ? credit?.contents[0].id : null,
            categories:
                credit?.tags
                    ?.filter((i) => i.scheme === 'Categories' && !(i.title in providers))
                    ?.map((i) => i.title) || [],
        };
        result = setLockedFlag(result);
        return result;
    });
};

export const transformGetByPIds = (response, trendingListIds) => {
    if (response && response?.entries) {
        (response.entries || []).sort((firstProgram, secondProgram) => {
            if (!trendingListIds) {
                return 0;
            }
            const firstProgramId = firstProgram.id.split('/').pop();
            const secondProgramId = secondProgram.id.split('/').pop();

            const firstProgramIndex = trendingListIds.indexOf(firstProgramId);
            const secondProgramIndex = trendingListIds.indexOf(secondProgramId);

            if (firstProgramIndex !== -1 && secondProgramIndex !== -1) return firstProgramIndex - secondProgramIndex;
        });
        return transformResponseList(response);
    }
    return [];
};

export const transformMpxEntries = (mpxResponse: { entries: [] }) => {
    return mpxResponse?.entries?.map((entry) => transformMpxAllAssetsResponseDetails({ entries: [entry] }));
};

export const transformMpxAllAssetsResponseDetails = (responseData) => {
    const providers = h.getProviders();
    let transformedVOD: any = {};
    const entries = responseData.entries ? responseData.entries : null,
        vodItem = entries[0] ? entries[0] : null;
    let contentObject = [];
    if (!!vodItem && vodItem !== null) {
        transformedVOD.Id = vodItem.id;
        transformedVOD.paId = vodItem.id;
        transformedVOD.listingId = vodItem?.listingId ?? null;
        transformedVOD.guid = vodItem.guid ? vodItem.guid : '';
        transformedVOD.text = h.getLang() === 'en' ? vodItem.title : vodItem.titleLocalized.ar;
        transformedVOD.textEn = vodItem.title;
        transformedVOD.textAr = vodItem.titleLocalized.ar;
        transformedVOD.description = h.getLang() === 'en' ? vodItem.description : vodItem.descriptionLocalized.ar;
        transformedVOD.descriptionEn = vodItem.description;
        transformedVOD.descriptionAr = vodItem.descriptionLocalized.ar;
        transformedVOD.image = vodItem.thumbnails['portrait-highestResolution']
            ? vodItem.thumbnails['portrait-highestResolution'].url
            : '';
        transformedVOD.image_landscape = vodItem.thumbnails['landscape-highestResolution']
            ? vodItem.thumbnails['landscape-highestResolution'].url
            : '';
        transformedVOD.year = vodItem.year;
        transformedVOD.tags = vodItem.tags;
        transformedVOD.provider =
            vodItem?.tags?.filter((i) => i.scheme === 'Categories' && i.title in providers)?.map((i) => i.title) ?? [];
        transformedVOD.categories =
            vodItem?.tags?.filter((i) => i.scheme === 'Categories' && !(i.title in providers))?.map((i) => i.title) ||
            [];
        transformedVOD.genre =
            vodItem?.tags?.filter((i) => i.scheme === 'Genre' && i.title)?.map((el) => el.title) ?? [];
        transformedVOD.ratings = h.getGenreRating(vodItem.ratings);
        transformedVOD.duration = vodItem.runtime;
        transformedVOD.language = vodItem.languages;
        transformedVOD.programType = vodItem.programType;
        transformedVOD.tvSeasonEpisodeNumber = vodItem.tvSeasonEpisodeNumber;
        transformedVOD.seriesId = vodItem.seriesId;
        transformedVOD.tvSeasonNumber = vodItem.tvSeasonNumber;
        transformedVOD.tvSeasonId = vodItem.tvSeasonId;
        transformedVOD.category = 'VOD';
        transformedVOD.mediaId = vodItem.media && vodItem.media.length > 0 ? vodItem.media[0].id : null;
        transformedVOD.introEt = vodItem.pl1$introEt;
        transformedVOD.introSt = vodItem.pl1$introSt;
        transformedVOD.outroEt = vodItem.pl1$outroEt;
        transformedVOD.outroSt = vodItem.pl1$outroSt;
        transformedVOD.subscriptionGuids = vodItem.pl1$subscriptionGuids;
        transformedVOD.categoryType = vodItem.pl1$categoryType ?? null;
        transformedVOD.adEnabled = vodItem.pl1$adEnabled ?? null;
        transformedVOD.pl1$seasonOrderDescending = vodItem.pl1$seasonOrderDescending ?? null;
        contentObject = vodItem.media;
        if (
            vodItem.media.length > 0 &&
            !!vodItem.media[0] &&
            typeof vodItem.media[0].content !== 'undefined' &&
            vodItem.media[0].content !== null
        ) {
            contentObject = vodItem.media[0].content;
            //
            let trailerM3U8 = [];
            let streamingUrl = [];
            let trailerMedia = [];

            trailerM3U8 = contentObject.filter((cnt) => {
                return cnt.assetTypes[0] === 'Trailer-MP4';
            });

            trailerMedia = contentObject.filter((cnt) => {
                return cnt.assetTypes[0] === 'Trailer';
            });

            streamingUrl = contentObject.filter((cnt) => {
                return cnt.assetTypes[0] === 'Video' && cnt.format === 'M3U';
            });

            if (trailerM3U8.length > 0) {
                transformedVOD.trailer = trailerM3U8[0].streamingUrl;
            }
            if (trailerMedia.length > 0) {
                transformedVOD.trailerMediaUrl = trailerMedia[0].releases[0]?.url;
            }

            if (streamingUrl.length > 0) {
                transformedVOD.streamingUrl = streamingUrl[0].releases[0] ? streamingUrl[0].releases[0].url : '';
                //transformedVOD.streamingUrl = streamingUrl[0].streamingUrl;
            }
        }
    }
    transformedVOD = setLockedFlag(transformedVOD);
    return transformedVOD;
};

export const transformSeasonsResponse = (responseData) => {
    const transformedSeasonsList = [];
    const entries = responseData.entries ? responseData.entries : null;
    if (typeof entries !== 'undefined' && entries !== null && entries !== false) {
        entries.map((vod) => {
            transformedSeasonsList.push({
                Id: vod.id,
                guid: vod.guid || '',
                text: vod.title,
                tvSeasonNumber: vod.tvSeasonNumber,
                image: vod.thumbnails['portrait-highestResolution']
                    ? vod.thumbnails['portrait-highestResolution'].url
                    : '',
                image_landscape: vod.thumbnails['landscape-highestResolution']
                    ? vod.thumbnails['landscape-highestResolution'].url
                    : '',
                type: 'link',
                label: {
                    en: __('tv_series_details_season') + ' ' + vod.tvSeasonNumber,
                    ar: __('tv_series_details_season') + ' ' + vod.tvSeasonNumber,
                },
                value: vod.id,
                subscriptionGuids: vod.pl1$subscriptionGuids,
            });
        });

        return transformedSeasonsList;
    }
    return null;
};

export const transformProgram = (item) => {
    item.startTime = Number(item.startTime);
    item.endTime = Number(item.endTime);

    const searchVideoItem: any = {};
    if (item.thumbnails['landscape-highestResolution']) {
        searchVideoItem.imageURL = item.thumbnails['landscape-highestResolution'].url || '';
    }
    searchVideoItem.title = h.getLang() === 'en' ? item.title : item.titleLocalized['ar'];
    searchVideoItem.titleEn = item.title;
    searchVideoItem.name = item.title;
    searchVideoItem.dateTime = channelsUtil.formatPastDuration(new Date(item.startTime).getTime());
    searchVideoItem.startTime = item.startTime;
    searchVideoItem.endTime = item.endTime;
    searchVideoItem.episodeNumber = item.listingCount;
    searchVideoItem.isEpisodesAvailable = parseInt(item.listingCount, 10) > 1;
    searchVideoItem.paId = item.id;
    searchVideoItem.description = h.getLang() === 'en' ? item.description : item.descriptionLocalized['ar'];
    searchVideoItem.descriptionEn = item.description;
    searchVideoItem.listingCount = item.listingCount || 0;
    searchVideoItem.listings = item.listings || [];
    searchVideoItem.stationId = item.stationId;
    searchVideoItem.timings = searchVideoItem.dateTime;
    searchVideoItem.metaInfo = searchVideoItem.dateTime;
    searchVideoItem.rating = (item.ratings && item.ratings.length && h.getGenreRating(item.ratings)) || '';
    searchVideoItem.ratings = (item.ratings && item.ratings.length && h.getGenreRating(item.ratings)) || '';
    searchVideoItem.category = 'LINEAR';
    searchVideoItem.mediaId = item.media && item.media.length > 0 ? item.media[0].id : null;
    searchVideoItem.listingId = item?.listingId ?? null;
    searchVideoItem.guid = item?.guid ?? null;
    searchVideoItem.subscriptionGuids = item?.subGuids ?? [];

    return searchVideoItem;
};
